module.exports = __webpack_public_path__ + "img/public_activities_2.1b0c0fbd.png";